import React, { useState } from 'react';
import './Modal.css';

const DeleteConfirmationModal = ({ onClose, onConfirm }) => {
  const [input, setInput] = useState('');

  const handleConfirm = () => {
    if (input.trim().toLowerCase() === 'delete') {
      onConfirm();
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Confirm Deletion</h3>
        <p>Type <strong>delete</strong> below to confirm:</p>
        <input
          type="text"
          value={input}
          onChange={e => setInput(e.target.value)}
          placeholder="Type 'delete' to confirm"
        />
        <div className="modal-actions">
          <button className="cancel-button" onClick={onClose}>Cancel</button>
          <button
            className="delete-button"
            disabled={input.trim().toLowerCase() !== 'delete'}
            onClick={handleConfirm}
          >
            Confirm Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
